<script lang="ts">
// 멀티루트(헤더 + sub-header)에서 소비처가 넘긴 class 등 attr이 base-header로만 전달되도록 자동 상속을 끈다.
export default { inheritAttrs: false };
</script>

<script setup lang="ts">
import BaseHeader from '@/common/components/templates/BaseHeader.vue';
import TimeController from '@/common/components/molecules/timeController/TimeController.vue';
import NavigationSubHeader from '@/common/components/molecules/navigationSubHeader/NavigationSubHeader.vue';
import {
  Emit,
  Props,
  setup,
} from '@/common/components/molecules/navigationHeader/navigationHeader.setup';
import { DEFAULT_PERIOD_ITEMS } from '@/common/components/molecules/timeController/constants';
import BreadCrumbs from '@/common/components/molecules/breadCrumbs/BreadCrumbs.vue';
import OverviewAlert from '@/common/components/organisms/overviewAlert/OverviewAlert.vue';

const props = withDefaults(defineProps<Props>(), {
  usePath: false,
  useTimePeriod: false,
  timePeriodItems: () => DEFAULT_PERIOD_ITEMS,
});
const emit = defineEmits<Emit>();

const { timeIndicatorRef, routeDisplayText, selectedPeriodInfo, onUpdatePeriodInfo } = setup(
  props,
  emit,
);

defineExpose({
  togglePause: () => {
    timeIndicatorRef.value?.togglePause();
  },
});
</script>

<template>
  <base-header
    class="navigation-header"
    v-bind="$attrs"
  >
    <template #title>
      <div
        v-if="props.usePath"
        class="navigation-header__path"
      >
        <bread-crumbs />
      </div>
      <template v-else>
        <slot name="title" />
        <span class="navigation-header__name view-name">
          {{ routeDisplayText }}
        </span>
      </template>
    </template>
    <template #default>
      <slot />
      <overview-alert
        v-if="props.alertInfo"
        :alert-info="props.alertInfo"
      />

      <div
        v-if="props.useTimePeriod"
        class="navigation-header__right"
        :style="{ right: props.alertInfo ? '44px' : '12px' }"
      >
        <time-controller
          ref="timeIndicatorRef"
          :period-info="selectedPeriodInfo"
          :period-items="props.timePeriodItems"
          :mode="props.timePeriodMode"
          :options="props.timePeriodOptions"
          size="md"
          class="navigation-header__time-period"
          @update-period-info="onUpdatePeriodInfo"
        />
        <slot name="action" />
      </div>
    </template>
  </base-header>
  <navigation-sub-header />
</template>

<style lang="scss">
.navigation-header {
  .app-additional-info {
    position: relative;
  }
  &__path {
    display: flex;
    align-items: center;
  }
  &__right {
    display: flex;
    position: absolute;
    top: 50%;
    gap: 13px;
    transform: translateY(-50%);
  }
}
</style>
